<template>
  <div class="flex flex-col justify-between">
    <div :class="{ 'flex items-start space-x-12': sticky }">
      <div
        class="bg-static-default-low border-static-default-low rounded-lg shrink-0"
        :class="sticky ? 'w-32 lg:w-[88px] lg:p-8 lg:border' : 'p-16 border'"
      >
        <RevIllustration
          :alt="product.title"
          class="w-full"
          :height="sticky ? 88 : 218"
          :sizes="sticky ? '88px' : '218px'"
          :src="product.image"
          :width="sticky ? 88 : 218"
        />
      </div>
      <div class="min-w-0" :class="{ 'mt-12': !sticky }">
        <span
          class="text-static-default-hi"
          :class="sticky ? 'body-1-bold line-clamp-2' : 'heading-2'"
          >{{ product.title }}</span
        >
        <div v-if="product.price" data-spec="price-information">
          <div class="text-static-default-low caption">
            {{ i18n(translations.startingFrom) }}
          </div>
          <ProductPrice
            :discounted-price="
              product.discountedPrice && i18n.price(product.discountedPrice)
            "
            :price="i18n.price(product.price)"
            :price-new="
              sticky
                ? undefined
                : product.priceNew && i18n.price(product.priceNew)
            "
          />
        </div>
      </div>
    </div>
    <RevButton
      class="w-full"
      :class="sticky ? 'mt-8 lg:mt-16' : 'mt-24'"
      :size="sticky ? 'small' : 'medium'"
      :to="product.url"
      variant="primary"
    >
      {{ i18n(translations.seeOptions) }}
    </RevButton>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { RevIllustration } from '@ds/components/Illustration'

import type { ComparisonProduct } from '../../models/product'
import ProductPrice from '../ProductPrice.vue'

import translations from './ProductComparison.translations'

const i18n = useI18n()

withDefaults(
  defineProps<{
    product: ComparisonProduct
    sticky?: boolean
  }>(),
  {
    sticky: false,
  },
)
</script>
